/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAccoladeRequest
 */
export interface CreateAccoladeRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof CreateAccoladeRequest
     */
    readonly $schema?: string;
    /**
     * The description of the accolade
     * @type {string}
     * @memberof CreateAccoladeRequest
     */
    description: string;
    /**
     * The name of the accolade
     * @type {string}
     * @memberof CreateAccoladeRequest
     */
    name: string;
    /**
     * The primary color of the accolade
     * @type {string}
     * @memberof CreateAccoladeRequest
     */
    primaryColor: string;
    /**
     * The priority of the accolade
     * @type {number}
     * @memberof CreateAccoladeRequest
     */
    priority: number;
    /**
     * The secondary color of the accolade
     * @type {string}
     * @memberof CreateAccoladeRequest
     */
    secondaryColor: string;
    /**
     * The short name of the accolade
     * @type {string}
     * @memberof CreateAccoladeRequest
     */
    shortName: string;
}

/**
 * Check if a given object implements the CreateAccoladeRequest interface.
 */
export function instanceOfCreateAccoladeRequest(value: object): value is CreateAccoladeRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('primaryColor' in value) || value['primaryColor'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('secondaryColor' in value) || value['secondaryColor'] === undefined) return false;
    if (!('shortName' in value) || value['shortName'] === undefined) return false;
    return true;
}

export function CreateAccoladeRequestFromJSON(json: any): CreateAccoladeRequest {
    return CreateAccoladeRequestFromJSONTyped(json, false);
}

export function CreateAccoladeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAccoladeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'description': json['description'],
        'name': json['name'],
        'primaryColor': json['primary_color'],
        'priority': json['priority'],
        'secondaryColor': json['secondary_color'],
        'shortName': json['short_name'],
    };
}

export function CreateAccoladeRequestToJSON(json: any): CreateAccoladeRequest {
    return CreateAccoladeRequestToJSONTyped(json, false);
}

export function CreateAccoladeRequestToJSONTyped(value?: Omit<CreateAccoladeRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'name': value['name'],
        'primary_color': value['primaryColor'],
        'priority': value['priority'],
        'secondary_color': value['secondaryColor'],
        'short_name': value['shortName'],
    };
}

